import React from 'react';
import useToggle from '../../Hooks/useToggle';
import BackToTop from '../BackToTop';
import Drawer from '../Mobile/Drawer';
import AboutHomeEight from './AboutHomeEight';
import BlogHomeEight from './BlogHomeEight';
import FooterHomeEight from './FooterHomeEight';
import HeaderHomeEight from './HeaderHomeEight';
import HeroHomeEight from './HeroHomeEight';
import SignupHomeEight from './SignupHomeEight';
import CounterArea from './CounterArea';
import FeaturesHomeEight from './FeaturesHomeEight';
import ServicesHomeEight from './ServicesHomeEight';

function HomeEight() {
    const [drawer, setDrawer] = useToggle(false);
    return (
        <>
            <Drawer drawer={drawer} action={setDrawer.toggle} />
            <HeaderHomeEight drawer={drawer} action={setDrawer.toggle} />
            <HeroHomeEight />
            <AboutHomeEight />
            <FeaturesHomeEight />           
            <BlogHomeEight />
            <ServicesHomeEight />
            <CounterArea />           
            <SignupHomeEight className="appie-signup-8-area" />
            <FooterHomeEight />
            <BackToTop className="back-to-top-8" />
        </>
    );
}

export default HomeEight;
